import React from "react";
import { useSelector } from "react-redux";

import useModal from "../../Hooks/useModal";

const ModalManager = ({ modals, data, onCloseHandlers, defaultOnClose  }) => {
    const activeModal = useSelector((state) => state.CommonReducer.currentlyActiveModal);
    const { closeModal } = useModal();

    const getCloseHandler = (modalIdentifier) => {
        if (!modalIdentifier) return () => {};
        
        // Check for specific handler for specific modal.
        if (onCloseHandlers?.[modalIdentifier]) {
            return () => {
                onCloseHandlers[modalIdentifier]();
                closeModal();
            };
        }

        if (defaultOnClose){
            return () => {
                defaultOnClose();;
                closeModal();
            };
        } 

        return closeModal;
    };


    if (!activeModal) return null;

    const ModalComponent = modals[activeModal];
    const closeHandler = getCloseHandler(activeModal);

    return ModalComponent ? <ModalComponent onClose={closeHandler} /> : null;
};

export default ModalManager;